'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const BaseControllerBackedDirective=require('../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');let

FatigueThresholdLabelDirective=function(_BaseControllerBacked){_inherits(FatigueThresholdLabelDirective,_BaseControllerBacked);function FatigueThresholdLabelDirective(){_classCallCheck(this,FatigueThresholdLabelDirective);return _possibleConstructorReturn(this,_BaseControllerBacked.apply(this,arguments))}FatigueThresholdLabelDirective.prototype.












factory=function factory(){
let directive=_BaseControllerBacked.prototype.factory.call(this);
directive.replace=!0;
return directive;
};_createClass(FatigueThresholdLabelDirective,[{key:'objectBindings',get:function(){return['leftMargin','areaWidth','minRange','maxRange','currentValue']}},{key:'templateUrl',get:function(){return'/templates/directives/fatigueThresholdLabelDirective/fatigueThresholdLabelTemplate'}},{key:'controller',get:function(){return FatigueThresholdLabelDirectiveController}}]);return FatigueThresholdLabelDirective}(BaseControllerBackedDirective);let


FatigueThresholdLabelDirectiveController=function(){
function FatigueThresholdLabelDirectiveController(){_classCallCheck(this,FatigueThresholdLabelDirectiveController);
this._labelWidth=120;
}_createClass(FatigueThresholdLabelDirectiveController,[{key:'_leftOuterMargin',get:function()

{
return this.leftMargin-this._labelWidth/2;
}},{key:'_leftInnerPercent',get:function()

{
return(this.currentValue-this.minRange)/(this.maxRange-this.minRange);
}},{key:'_leftInnerMargin',get:function()

{
return this.areaWidth*this._leftInnerPercent;
}},{key:'leftPosition',get:function()

{
return this._leftOuterMargin+this._leftInnerMargin;
}}]);return FatigueThresholdLabelDirectiveController}();



module.exports=FatigueThresholdLabelDirective;
//# sourceMappingURL=fatigueThresholdLabelDirective.js.map
